import React from "react";

export default function Loader() {
    return (
        <div className="flex flex-col items-center justify-center min-h-[400px] w-full p-8 transition-all duration-300">
            <div className="relative flex items-center justify-center">
                {/* Outer spinning gradient ring */}
                <div className="w-16 h-16 rounded-full border-4 border-t-indigo-600 border-r-purple-600 border-b-pink-500 border-l-transparent animate-spin"></div>
                
                {/* Inner pulsing circle */}
                <div className="absolute w-8 h-8 rounded-full bg-gradient-to-tr from-indigo-500 to-purple-500 opacity-75 animate-ping"></div>
            </div>
            
            {/* Loading text with shimmer effect */}
            <div className="mt-6 text-center">
                <span className="text-sm font-semibold tracking-wider text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-500 animate-pulse">
                    Chargement en cours...
                </span>
                <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">
                    Veuillez patienter un instant
                </p>
            </div>
        </div>
    );
}
